module.exports = __webpack_public_path__ + "media/src/pages/Login/images/login-alternate-94c493f173df621f9707424c30f7ecdd.svg";